import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, Button } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import User from 'services/user2';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import CompanyService from 'services/company2';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
import Util from 'lib/util.js';
import useDetail from 'hooks/useDetail';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import CommonFns from 'functions/common.ts';
import PaymentService from 'services/payment';

function PaymentAdvanceDetail(props) {
  const Config = {
    purchase: {
      title: '预付款详情',
      apiPath: '/prepayOrder/getDetail',
      publishApiPath: '/prepayOrder/publish',
      confirmApiPath: '/prepayOrder/audit',
      customerNameKey: 'companyName',
      companyCodeKey: 'companyCode',
      vendorNameKey: 'innerVendorName',
      arrEnumField: [
        {
          mainKey: 'B02_PrepayOrder_status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      idField: 'ppmXkNo',
      wfmCode: '1032'
    },
    sale: {
      title: '预付款详情',
      apiPath: '/cPrepayOrder/getDetail',
      customerNameKey: 'companyName',
      companyCodeKey: 'companyCode',
      vendorNameKey: 'innerCustomerName',
      arrEnumField: [
        {
          mainKey: 'B02_PrepayOrder_status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      idField: 'ppmXkNo'
    }
  };

  const config = Config[props.type];

  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    decimalPlace,
    fileList,
    moreSign1,
    handleMore,
    setShowLoading,
    setFileList,
    detail,
    setDetail,
    workflow,
    forceUpdate,
    self
  } = useDetail(props, config);

  const { state, dispatch } = useContext(ActionContext);
  const [boxState, setBoxState] = useState({
    1: true
  });
  const [list, setList] = useState([]);

  //处理详情数据
  self.afterGetDetail = function (data) {
    //扁平化付款数据
    if (data.payInfo && Array.isArray(data.payInfo.rcpXkNoList)) {
      data.totalReceiptAmount = data.payInfo.totalReceiptAmount;
      data.rcpXkNoList = data.payInfo.rcpXkNoList.join(', ');
    }
    setDetail(data);
  };

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);
    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  // function handleBoxState(idx) {
  //   boxState[idx] = !boxState[idx];
  //   setBoxState(boxState);
  //   forceUpdate();
  // }

  //获取提交参数
  function getPostbody(apiPath) {
    let postbody = {
      ppmXkNo: self.id,
      companyCode: companyCode,
      apiPath: apiPath
    };
    return postbody;
  }

  //发布预付款单
  function publish() {
    let postbody = getPostbody(config.publishApiPath);
    PaymentService.publishAdvPayment(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //确认预付款单
  function confirm() {
    let postbody = getPostbody(config.confirmApiPath);
    PaymentService.confirmAdvPayment(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      <div className="m-details-container">
        <div className="m-details-item">
          <div className="details-item-title">
            <label>基础信息</label>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                {self.isPurchase && (
                  <li>
                    <span className="field-label">采购方</span>
                    <div className="field-value">{detail.companyName}</div>
                  </li>
                )}
                {!self.isPurchase && (
                  <li>
                    <span className="field-label">客户名称</span>
                    <div className="field-value">
                      {detail[config.vendorNameKey]}
                    </div>
                  </li>
                )}
                <li>
                  <span className="field-label">单号</span>
                  <div className="field-value">{detail.ppmXkNo}</div>
                </li>
                <li>
                  <span className="field-label">收货部门</span>
                  <div className="field-value">{detail.profitCenterName}</div>
                </li>
                <li>
                  <span className="field-label">供应商</span>
                  {self.isPurchase && (
                    <div className="field-value">
                      {detail.innerVendorName}({detail.innerVendorCode})
                    </div>
                  )}
                  {!self.isPurchase && (
                    <div className="field-value">{detail.companyName}</div>
                  )}
                </li>
                <li>
                  <span className="field-label">纳税人识别号</span>
                  <div className="field-value">{detail.vendorCreditCode}</div>
                </li>
                <li>
                  <span className="field-label">开户行</span>
                  <div className="field-value">{detail.vendorBankName}</div>
                </li>
                <li>
                  <span className="field-label">银行账号</span>
                  <div className="field-value">{detail.vendorBankCardNo}</div>
                </li>
                <li>
                  <span className="field-label">币别</span>
                  <div className="field-value">{detail.currencyName}</div>
                </li>
                <li>
                  <span className="field-label">预付款金额</span>
                  <div className="field-value">
                    {formatNumber(
                      detail.prepayTotalAmount,
                      decimalPlace.AMOUNT
                    )}
                  </div>
                </li>
                <li>
                  <span className="field-label">支付方式</span>
                  <div className="field-value">{detail.paymentTypeName}</div>
                </li>
                <li>
                  <span className="field-label">预付款类型</span>
                  <div className="field-value">{detail.prepayTypeName}</div>
                </li>
                <li>
                  <span className="field-label">实际付款</span>
                  <div className="field-value">
                    {formatNumber(
                      detail.totalReceiptAmount,
                      decimalPlace.AMOUNT
                    )}
                  </div>
                </li>
                <li>
                  <span className="field-label">付款单号</span>
                  <div className="field-value">{detail.rcpXkNoList}</div>
                </li>
                <li>
                  <span className="field-label">状态</span>
                  <div className="field-value">
                    <span
                      className={
                        'u-sign ' +
                        CommonFns.getStatusClass(
                          'B02_PrepayOrder_status',
                          detail.status
                        )
                      }
                    >
                      {detail.statusName}
                    </span>
                  </div>
                </li>
                {/* 审批流状态 仅开启后才显示 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批环节</span>
                    <div className="field-value">
                      <WorkflowStatus
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                      />
                    </div>
                  </li>
                )}
                {/* 审批流按钮 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批操作</span>
                    <div className="field-value">
                      <WorkflowButtons
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                        onChange={() => {
                          self.getDetail();
                        }}
                        onComplete={() => {
                          self.getDetail();
                        }}
                      />
                    </div>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>

        {/*付款明细 */}
        {!Util.isEmpty(detail.lineList) && (
          <div className="m-details-item">
            <div className="details-item-title">
              <label>付款明细</label>
            </div>

            <div className="details-item-content">
              {detail.lineList.map((item, index) => (
                <div className="content-line line-list-item" key={index}>
                  <div className="line-list-item-title">
                    <span>序号 {index + 1}</span>
                  </div>
                  <ul className="field-list">
                    <li>
                      <span className="field-label">采购单号</span>
                      <div className="field-value">{item.poErpNo}</div>
                    </li>
                    <li>
                      <span className="field-label">订单金额</span>
                      <div className="field-value">
                        {formatNumber(item.poTotalAmount, decimalPlace.AMOUNT)}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">未转预付款金额</span>
                      <div className="field-value">
                        {formatNumber(
                          item.curMaxTransferAmount,
                          decimalPlace.AMOUNT
                        )}
                      </div>
                    </li>
                    {self.isPurchase && (
                      <li>
                        <span className="field-label">已退款金额</span>
                        <div className="field-value">
                          {formatNumber(
                            item.infos?.toPrepayReturnAmount,
                            decimalPlace.AMOUNT
                          )}
                        </div>
                      </li>
                    )}
                    <li>
                      <span className="field-label">预付款比例</span>
                      <div className="field-value">{item.toPrepayPercent}%</div>
                    </li>
                    <li>
                      <span className="field-label">预付款金额</span>
                      <div className="field-value">
                        {formatNumber(item.prepayAmount, decimalPlace.AMOUNT)}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">付款说明</span>
                      <div className="field-value">{item.curDesc}</div>
                    </li>
                  </ul>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {User.checkAuth('10041003') &&
            [0, 3, 4].includes(detail.status) &&
            workflow.data &&
            workflow.data['prepayments_publish_1'].complete && (
              <Button
                type="default"
                onClick={() => {
                  publish();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                确认发出
              </Button>
            )}
        </div>
      )}
      {self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {User.checkAuth('10041006') &&
            [1].includes(detail.status) &&
            workflow.data &&
            workflow.data['prepayments_cfm_2'].complete && (
              <Button
                type="default"
                onClick={() => {
                  confirm();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                确认
              </Button>
            )}
        </div>
      )}

      {/* <span
            *ngIf="user.checkAuth('10041006') && detail.status === 1 && workflow.data?.prepayments_cfm_2?.complete"
            class="u-btn"
            (click)="confirm()"
            >{{ 'BUTTON.OK' | translate }}</span
          > */}

      <Modal></Modal>
    </div>
  );
}

PaymentAdvanceDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentAdvanceDetail);
